import { StyleSheet } from 'react-native';

export const twinkleDotsStyles = StyleSheet.create({
  root: {
    ...StyleSheet.absoluteFillObject,
  },
  dot: {
    position: 'absolute',
    backgroundColor: '#A78BFA',
  },
});
